
import BaseApi from './BaseApi';
// 多车监控
let API = '/vehiclescheduling'
export default class MultiCarMonitorApi extends BaseApi {
  // ***************************多车监控***************************
  // 1.获取历史轨迹
  async historyData(info) {
    return await this.get(`${API}/GclVehicleMonitor/historyData`, info);
  }
  // 1.获取全部车辆数据接口
  async gclVehicleMonitor(info) {
    return await this.get(`${API}/GclVehicleMonitor`, info);
  }
  // 1.请求告警信息
  async getVehicleInfoByWarn(info) {
    return await this.get(`${API}/GclVehicleMonitor/getVehicleInfoByWarn/${info}`);
  }
  // 基本信息
  async getVehicleInfo(info) {
    return await this.get(`${API}/GclVehicleMonitor/getVehicleInfo/${info.ts}/${e.vin}`);
  }
}

export const multiCarMonitorApi = new MultiCarMonitorApi();